import { render, staticRenderFns } from "./FacilitiesWidget.vue?vue&type=template&id=1c25da3c&scoped=true"
import script from "./FacilitiesWidget.vue?vue&type=script&lang=js"
export * from "./FacilitiesWidget.vue?vue&type=script&lang=js"
import style0 from "./FacilitiesWidget.vue?vue&type=style&index=0&id=1c25da3c&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c25da3c",
  null
  
)

export default component.exports